module.exports = __webpack_public_path__ + "img/electronic_use_selected.5298305a.svg";